import { IampLogger, LogTag } from '../../../utils/IampLogger'
import { StereoToSpatialResult } from './StereoToSpatialResult'
import '../styles/homeresult.css'
import './styles/stereo-to-spatial-result.css'

const HomeStereoToSpatialResult = (props: StereoToSpatialResult) => {
  IampLogger.debug(LogTag.HomePage, 'Result props:', props)

  return (
    <div className="module-result">
      <div className="module-data">
        <div className="data-title">Spatialization complete</div>
        <div className="data-detail">
          Your immersive and binaural files are ready!
        </div>
      </div>
    </div>
  )
}

export default HomeStereoToSpatialResult
